var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-date-picker',_vm._b({model:{value:(_vm.valueMoment),callback:function ($$v) {_vm.valueMoment=$$v},expression:"valueMoment"}},'a-date-picker',_vm.passedProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }